import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=5b84b1fd&scoped=true&"
import script from "./Milestones.vue?vue&type=script&lang=js&"
export * from "./Milestones.vue?vue&type=script&lang=js&"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=5b84b1fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b84b1fd",
  null
  
)

export default component.exports